import React, { useEffect, useState, useContext } from 'react'
import { useTranslation } from 'react-i18next'

import useFetchStatus from "customHooks/useFetchStatus"
import CustomTable from "../components/ReactTable"
import TitleWithBtn from "../components/Titles/TitleWithBtn"
import { NetworkErrorToast, successToast, errorToast } from "../components/toast"
import _ from "lodash"
import { updateDoc, handleTicket,mappingStaffs, checkTickets, fetchData, getTicketStep, getTicketStep2, addDate } from "./handler"
import moment from "moment"
import MessageModel from "./messageModal"
import PreviewModal from "./previewModal"
import RedirectModal from "./redirectModal"
import { UserContext } from "context/auth";


function Tasks() {

    let { t } = useTranslation()
    let inprogress = { field: "inProgress", value: true }

    let [selectedTicket, setSelectedTicket] = useState({})
    let [updateList, setUpdateList] = useState(0)
    let [inprogressTickets, inprogressError, isInprogressLoading] = useFetchStatus(`tickets`, {}, [updateList], inprogress)
    let [staffs, staffsError, isStaffsLoading] = useFetchStatus(`staff`, {}, [], null)

    let { user: currentUser } = useContext(UserContext)
    let currentStaff = currentUser.id

    let [isOpen, setIsOpen] = useState(false)
    let [isHandled, setHandled] = useState(false)
    let [isDecline, setDecline] = useState(false)
    let [isComplete, setComplete] = useState(false)

    let [filteredTasks, setFilteredTasks] = useState()
    let [tasks, setTasks] = useState([])
    let [handeledTaskList, setHandeledTaskList] = useState([])
    let [isHandling, setHandling] = useState(false)

    // preview Request Modal
    let [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false)

    // redirect ticket Modal
    let [isRedirectModalOpen, setIsRedirectModalOpen] = useState(false)

    const toggleModal = () => setIsOpen(!isOpen)

    useEffect(() => {
        setTasks(_.values(inprogressTickets))
    }, [inprogressTickets])

    useEffect(() => {
        setHandling(true)
        
        Promise.resolve(getTasks(tasks, currentStaff, _.values(staffs))).then(data => {
            setHandling(false)
            setHandeledTaskList(data)
        })

    }, [tasks])
    console.log(handeledTaskList)

    let updateTicketsList = () => setUpdateList(++updateList)

    const approveTicket = async (filesUrls, message, answerFormData = null) => {

        let task = selectedTicket

        let lastApproveNeed = task.getwayIds[task.getwayIds.length - 1] // to know if this approve is the last one nned to be approve

        let lastApprovedIndx = _.indexOf(task.getwayIds, lastApproveNeed)


        try {

            let docPath = `tickets/${task.id}`

            let ApprovedStaff = {
                id: currentStaff,
                approvedName: currentUser.name_en,
                date: moment().format('YYYY-MM-DD HH:mm:ss'),
                directed: !_.isEmpty(task.directedStaffs) && _.head(task.directedStaffs) === currentUser.id ? true : false,
                message: message,
                action: "approve",
                attatchment: !_.isEmpty(filesUrls) ? filesUrls : null,
                answerFormData,
            }
            let staffKey = Math.floor((Math.random() * 10000) + 1)
            task = {
                ...task,
                //approvedBy: !_.isEmpty(task.approvedBy) ? [...task.approvedBy, ApprovedStaff] : [ApprovedStaff],
                approvedBy: !_.isEmpty(task.approvedBy) ? {...task.approvedBy, [staffKey]: ApprovedStaff } : {[staffKey]: ApprovedStaff }
            }

            // get staff count in getwayIds
            let getwayCounts = _.map(_.groupBy(task.getwayIds), (getway, key) => {
                if (key === currentStaff)
                    return getway.length
            })
            console.log(getwayCounts)

            // get staff count in approvedBy list
            let approves = _.filter(_.values(task.approvedBy), approve => approve.directed == false)
            let approveCounts = _.map(_.groupBy(approves, (item) => item.id), (approve, key) => {
                if (key === currentStaff)
                    return approve.length
            })
            console.log(approveCounts)

            let isLastApprovment = _.find(getwayCounts, count => count !== undefined) === _.find(approveCounts, count => count !== undefined)

            // to  close the ticket if it's last staff
            if (_.isEmpty(task.directedStaffs) && isLastApprovment && approves.length === task.getwayIds.length) {

                task = { ...task, inProgress: false, isApproved: true, closedAt: moment().format('YYYY-MM-DD HH:mm:ss') }
            }

            //task = _.omit(task, 'getwayIds') // to remove the ticket getwayIds
            task = _.omit(task, 'date') // to remove the ticket handled date for displaying

             // decrement last directed length by 1
            if (!_.isEmpty(task.directedStaffs) && !_.isEmpty(task.directedStaffsLengths)) {
                task.directedStaffsLengths[0] = task.directedStaffsLengths[0] - 1
                if (task.directedStaffsLengths[0] == 0)
                    task.directedStaffsLengths.shift() // to remove item with value 0 (not be needed anymore)
            }
            
            if (!_.isEmpty(task.directedStaffs))
                task.directedStaffs.shift() // to remove staff  id from directedStaffs

            // save the updates & increase the counter
            await getTicketStep(task, _.values(staffs)) // to set next ticket step
            console.log(task)

            let increment = window.firebaseIncrement

            await Promise.all([
                updateDoc(task, docPath),
                updateDoc({ approved: increment }, 'counter/tickets')
            ])

            updateTicketsList()
            setHandled(false)
            successToast(t('request_was_approved'))

        } catch (error) {
            console.log(error)

        }
    }

    const approveAction = (index) => {
        let task = filteredTasks[index]
        setSelectedTicket(task)
        toggleModal()
    }

    const declineTicket = async (filesUrls, message, answerFormData = null) => {

        let task = selectedTicket

        try {
            let docPath = `tickets/${task.id}`

            let ApprovedStaff = {
                id: currentStaff,
                approvedName: currentUser.name_en,
                date: moment().format('YYYY-MM-DD HH:mm:ss'),
                directed: !_.isEmpty(task.directedStaffs) && _.head(task.directedStaffs) === currentUser.id ? true : false,
                message: message,
                action: "decline",
                attatchment: !_.isEmpty(filesUrls) ? filesUrls : null,
                answerFormData
            }
            let staffKey = Math.floor((Math.random() * 10000) + 1)

            if (!_.isEmpty(task.directedStaffs) && ApprovedStaff.directed == true && !_.isEmpty(task.directedStaffsLengths)) {
                if (!_.isEmpty(task.directedStaffsLengths)) {
                    task.directedStaffs.splice(0, _.head(task.directedStaffsLengths))
                    task.directedStaffsLengths.shift()
                }

                task = {
                    ...task,
                    approvedBy: !_.isEmpty(task.approvedBy) ? { ...task.approvedBy, [staffKey]: ApprovedStaff } : { [staffKey]: ApprovedStaff }
                }

            }

            else {

                task = {
                    ...task,
                    inProgress: false,
                    isApproved: false,
                    //message: note,
                    closedAt: moment().format('YYYY-MM-DD HH:mm:ss'),
                    //approvedBy: !_.isEmpty(task.approvedBy) ? [...task.approvedBy, ApprovedStaff] : [ApprovedStaff],
                    approvedBy: !_.isEmpty(task.approvedBy) ? {...task.approvedBy, [staffKey]: ApprovedStaff } : {[staffKey]: ApprovedStaff }
                }

                //if (!_.isEmpty(task.directedStaffs)) task.directedStaffs.shift() // to remove staff  id from directedStaffs
            }
            
            //task = _.omit(task, 'getwayIds') // to remove the ticket getwayIds
            task = _.omit(task, 'date') // to remove the ticket handled date for displaying

            await getTicketStep(task, _.values(staffs)) // to set next ticket step
            console.log(task)

            // save the updates & increase the counter
            let increment = window.firebaseIncrement

            await Promise.all([
                updateDoc(task, docPath),
                updateDoc({ rejected: increment }, 'counter/tickets')
            ])

            setDecline(false)

            updateTicketsList()// to refresh tasksList
            setHandled(false)
            successToast(t('request_was_declined'))

        } catch (error) {
            console.log(error)
        }
    }

    const completeAction = (index) => {
        let task = filteredTasks[index]
        setSelectedTicket(task)
        setComplete(true)
        toggleModal()
    }

    const completeTicket = async (filesUrls, message, answerFormData = null) => {

        let task = selectedTicket

        try {
            let docPath = `tickets/${task.id}`

            let ApprovedStaff = {
                id: currentStaff,
                approvedName: currentUser.name_en,
                date: moment().format('YYYY-MM-DD HH:mm:ss'),
                directed: !_.isEmpty(task.directedStaffs) && _.head(task.directedStaffs) === currentUser.id ? true : false,
                message: message,
                action: "complete",
                attatchment: !_.isEmpty(filesUrls) ? filesUrls : null,
                answerFormData
            }
            let staffKey = Math.floor((Math.random() * 10000) + 1)
            task = {
                ...task,
                inProgress: false,
                isCompleted: true,
                closedAt: moment().format('YYYY-MM-DD HH:mm:ss'),
                approvedBy: !_.isEmpty(task.approvedBy) ? {...task.approvedBy, [staffKey]: ApprovedStaff } : {[staffKey]: ApprovedStaff }
            }

            task = _.omit(task, 'date') // to remove the ticket handled date for displaying
            if(!_.isEmpty(task.directedStaffs)) task.directedStaffs.shift() // to remove staff  id from directedStaffs

            await getTicketStep(task, _.values(staffs)) // to set next ticket step
            console.log(task)

            // save the updates & increase the counter
            let increment = window.firebaseIncrement

            await Promise.all([
                updateDoc(task, docPath),
                updateDoc({ completed: increment }, 'counter/tickets')
            ])

            setComplete(false)

            updateTicketsList()// to refresh tasksList
            setHandled(false)
            successToast(t('request_was_completed'))

        } catch (error) {
            console.log(error)
        }
    }


    const declineAction = (index) => {
        let task = filteredTasks[index]
        setSelectedTicket(task)
        setDecline(true)
        toggleModal()
    }

    const previewTicket = (index) => {
        setSelectedTicket(filteredTasks[index])
        setIsPreviewModalOpen(true)
    }

    const redirectAction = (index) => {
        setSelectedTicket(filteredTasks[index])
        setIsRedirectModalOpen(true)
    }


    let redirectTicket = async (selectedStaffs, message , approvment, filesUrls) => {

        if (selectedStaffs.length === 0)
            return errorToast(t('please_select_a_staff'))

        try {
            let docPath = `tickets/${selectedTicket.id}`

            let approves = _.values(selectedTicket.approvedBy)

            let lastApproved = _.indexOf(approves, _.last(approves))
            let redirectedStaffs = _.map(selectedStaffs, 'innerValue')
            if (redirectedStaffs.includes("manager") || redirectedStaffs.includes("supervisor"))
                redirectedStaffs = await mappingStaffs(selectedTicket, redirectedStaffs)

            let increment = window.firebaseIncrement

            //getwayIds.splice(lastApproved + 1, 0, ...redirectedStaffs) // insert selected staff to ticket getwayIds

            //selectedTicket.getwayIds = getwayIds
            selectedTicket.directedStaffs = !_.isEmpty(selectedTicket.directedStaffs)? [...redirectedStaffs, ...selectedTicket.directedStaffs] : [...redirectedStaffs]
            selectedTicket.directedStaffsLengths = !_.isEmpty(selectedTicket.directedStaffsLengths)? [redirectedStaffs.length , ...selectedTicket.directedStaffsLengths] : [redirectedStaffs.length]
            let directedStaff = {
                directedBy: currentStaff,
                directedByName: currentUser.name_en,
                date: moment().format('YYYY-MM-DD HH:mm:ss'),
                directedStaffs: redirectedStaffs,
                directKey: increment,
                message: message,
                action: "redirect",
                approvment: approvment,
                attatchment: !_.isEmpty(filesUrls) ? filesUrls : null
            }
            let staffKey = Math.floor((Math.random() * 10000) + 1)
            selectedTicket = {
                ...selectedTicket,
                redirects: !_.isEmpty(selectedTicket.redirects) ? {...selectedTicket.redirects, [staffKey]: directedStaff } : {[staffKey]: directedStaff }
            }

            selectedTicket = _.omit(selectedTicket, 'date') // to remove the ticket handled date for displaying

            await getTicketStep(selectedTicket, _.values(staffs)) // to set next ticket step
            console.log(selectedTicket)
            // save the updates
            await updateDoc(selectedTicket, docPath)

            updateTicketsList()
            setHandled(false)
            successToast(t('request_was_redirected'))

        } catch (error) {
            console.log({ error })
            errorToast(t('something_wrong'))

        } finally {
        }
    }

    // get the actions based on the user permissions
    let getActionsList = () => {
        let actions = [
            { name: t('preivew'), onClick: previewTicket },
            { name: t('approve'), onClick: approveAction },
            { name: t('decline'), onClick: declineAction },
            { name: t('redirect'), onClick: redirectAction },
        ]

        let CanCompleteRequest = _.get(currentUser, 'permissons.CanCompleteRequest', false)

        if (CanCompleteRequest)
            actions.push({ name: t('complete'), onClick: completeAction })

        return actions
    }
    
    const Header = [
        {
            Header: "#",
            accessor: "number",
            type: "string",
            sortable: true,
        },
        {
            Header: t('requester_name'),
            accessor: "requesterName",
            type: "string",
        },
        {
            Header: t('form_name'),
            accessor: "form.name",
            type: "string",
        },
        {
            Header: t('due_date'),
            accessor: "dueDate",
            type: "firestoreTime",
        },
        {
            Header: t('priority'),
            accessor: "priority",
            type: "priorityTxt",
        },
        {
            Header: t('step'),
            accessor: "step",
            type: "string",
        },
        {
            Header: t('open_at'),
            accessor: "openedAt",
            type: "firestoreTime",
            sortable: true,
        },
        {
            Header: t('date_and_time'),
            accessor: "date",
            type: "dateAndTime",
        },
        {
            Header: " ",
            buttonTitle: 'actions',
            list: getActionsList(),
            type: "dropDownMenu",
            //isOutline: true,
            sortable: false,
        },
    ]

    return (
        <div className="content">

            <TitleWithBtn
                title={t('my_tasks')}
            />

            {/*Display Tasks list */}
            <CustomTable
                title={t('my_tasks')}
                header={Header}
                loading={isInprogressLoading || isHandling}
                body={handeledTaskList}
                hasSearchBar={true}
                searchBarTitle={t('search')}
                setFilterResult={setFilteredTasks}
                selectDateRangeBeforeExport={true}
                // loadMoreBtn={{
                //     onClick: fetchMoreData,
                //     isDisabled: !isTicketLoading && _.isEmpty(tickets)
                // }}
                dataQuery={null} // for search & export 
                dataHandler={(allTickets) => getTasks(allTickets, currentStaff, _.values(staffs))} // to handel the data after fetch
                exportData={handeledTaskList} // fixed data to export
            />

            {/* Add decline Message modal */}
            <MessageModel
                isOpen={isOpen}
                toggle={toggleModal}
                task={selectedTicket}
                isDecline={isDecline}
                isComplete={isComplete}
                approveTicket={approveTicket}
                declineTicket={declineTicket}
                completeTicket={completeTicket}
            />

            {/* Preview ticket modal */}
            <PreviewModal
                isOpen={isPreviewModalOpen}
                toggle={() => setIsPreviewModalOpen(false)}
                ticket={selectedTicket}
                staffs={staffs}
            />

            {/* Redirect ticket modal */}
            <RedirectModal
                isOpen={isRedirectModalOpen}
                toggle={() => setIsRedirectModalOpen(false)}
                ticket={selectedTicket}
                redirectTicket={redirectTicket}
            />


        </div>

    )
}

export default Tasks


async function getTasks (inprogressTickets, currentStaff, staffs) {
    let filteredTickets = await getInfo(inprogressTickets, currentStaff)

    filteredTickets = await getTicketStep2(filteredTickets, staffs)

    return filteredTickets

}

let getInfo = async (tickets, currentStaff) => {

    let filteredTickets = []

    await Promise.all(_.map(tickets, async (ticket) => {
        ticket = addDate(ticket)

        //ckeck if the ticket is staff task 
        let task = await checkTickets(ticket, /*getwayIds,*/ currentStaff)

        // push to the filtered tickets
        if (!_.isEmpty(task)) filteredTickets.push(task)

        return filteredTickets

    })
    )

     return filteredTickets

}